import {
  Combobox,
  ComboboxData,
  ComboboxParsedItem,
  ComboboxProps,
  useCombobox,
} from '@mantine/core';

import classes from './combobox.module.css';

export * from './Autocomplete/Autocomplete';
export * from './MultiSelect/MultiSelect';
export * from './MultiSelect/SelectValue';
export * from './Select/Select';

export * from './TagsInput/TagsInput';

const ComboboxDefaults = Combobox.extend({
  classNames: {
    dropdown: classes.dropdown,
    options: classes.options,
    option: classes.option,
  },
});

export { Combobox, ComboboxDefaults, useCombobox };
export type { ComboboxData, ComboboxParsedItem, ComboboxProps };
